'use strict';

angular.module('amexReconciliationApp')
  .factory('FlashService',
    function FlashService() {
      return {
        message: undefined
      };
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/FlashService.js
// module id = 638
// module chunks = 0